import React from "react";
import { SVG, IconProps } from "../SVG";

const DEFAULT_H = 24;
const DEFAULT_W = 56;

export const Throbber = ({
    width = DEFAULT_W,
    height = DEFAULT_H,
    color = "#fff",
    ...props
}: IconProps) => {
    return (
        <SVG
            height={height}
            width={width}
            viewBox="0 0 32 24"
            fill="currentColor"
            stroke="none"
            {...props}
        >
            <circle fill={color} cx="0" cy="12" r="5">
                <animate
                    attributeName="opacity"
                    dur="1s"
                    values="0;1;0"
                    repeatCount="indefinite"
                    begin="0.1"
                />
            </circle>
            <circle fill={color} cx="16" cy="12" r="5">
                <animate
                    attributeName="opacity"
                    dur="1s"
                    values="0;1;0"
                    repeatCount="indefinite"
                    begin="0.2"
                />
            </circle>
            <circle fill={color} cx="32" cy="12" r="5">
                <animate
                    attributeName="opacity"
                    dur="1s"
                    values="0;1;0"
                    repeatCount="indefinite"
                    begin="0.3"
                />
            </circle>
        </SVG>
    );
};

Throbber.displayName = "Throbber";
